import { OTP_METHODS, type OtpMethod } from '@/core/api';

const MASK = '•••';

/**
 * A masked address as the code screens show it: `e•••@…` for an email and
 * `•••19` for a phone. Cognito masks both halves of an email (`e***@g***`),
 * the legacy api only the local part (`e****@example.com`); a domain that
 * is already masked becomes `…`. Undefined when there is nothing to show.
 */
export function maskDestination(method: OtpMethod, masked = ''): string | undefined {
  if (method === OTP_METHODS.EMAIL) {
    const [local, domain] = masked.split('@');
    if (!local || domain === undefined) return undefined;
    const first = local[0] === '*' ? '' : local[0];
    return `${first}${MASK}@${!domain || domain.includes('*') ? '…' : domain}`;
  }
  if (method === OTP_METHODS.SMS) {
    const digits = masked.replace(/\D/g, '');
    return digits.length >= 2 ? `${MASK}${digits.slice(-2)}` : undefined;
  }
  return undefined;
}

/**
 * "We emailed a code to e•••@…" / "We texted a code to •••19". A mask in a
 * shape this does not know is shown as given rather than dropped.
 */
export function codeSentMessage(method: OtpMethod, masked = ''): string | undefined {
  if (method === OTP_METHODS.APP) return undefined;
  const destination = maskDestination(method, masked) ?? masked.trim();
  if (!destination) return undefined;
  return `We ${method === OTP_METHODS.EMAIL ? 'emailed' : 'texted'} a code to ${destination}`;
}
